import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "vld-parent" }
const _hoisted_2 = { class: "card mb-5 mb-xl-10" }
const _hoisted_3 = {
  id: "kt_account_profile_details",
  class: "collapse show"
}
const _hoisted_4 = { class: "card-body border-top p-9" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "row mb-6" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, "Informasi Umum Sekolah")
], -1)
const _hoisted_6 = { class: "row mb-6" }
const _hoisted_7 = { class: "col-lg-6 fv-row" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label required fw-bold fs-6" }, "Sekolah", -1)
const _hoisted_9 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_10 = { class: "fv-help-block" }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { class: "col-lg-6 fv-row" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label required fw-bold fs-6" }, "Kelas", -1)
const _hoisted_14 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_15 = { class: "fv-help-block" }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { class: "row mb-6" }
const _hoisted_18 = { class: "col-lg-6 fv-row" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label required fw-bold fs-6" }, "Kelas Detail", -1)
const _hoisted_20 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_21 = { class: "fv-help-block" }
const _hoisted_22 = { key: 1 }
const _hoisted_23 = { class: "col-lg-6 fv-row" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label required fw-bold fs-6" }, "Nomor Identitas", -1)
const _hoisted_25 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_26 = { class: "fv-help-block" }
const _hoisted_27 = { key: 1 }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "row mb-6" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, "Biodata Siswa")
], -1)
const _hoisted_29 = { class: "row mb-6" }
const _hoisted_30 = { class: "col-lg-6 fv-row" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label required fw-bold fs-6" }, "Nama", -1)
const _hoisted_32 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_33 = { class: "fv-help-block" }
const _hoisted_34 = { key: 1 }
const _hoisted_35 = { class: "col-lg-6 fv-row" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label required fw-bold fs-6" }, "Jenis Kelamin", -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: ""
}, "Pilih Jenis Kelamin", -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("option", {
  value: "MALE",
  key: "MALE"
}, "Laki-Laki", -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("option", {
  value: "FEMALE",
  key: "FEMALE"
}, "Perempuan", -1)
const _hoisted_40 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_41 = { class: "fv-help-block" }
const _hoisted_42 = { key: 1 }
const _hoisted_43 = { class: "row mb-6" }
const _hoisted_44 = { class: "col-lg-6 fv-row" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label required fw-bold fs-6" }, "Tanggal Lahir", -1)
const _hoisted_46 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_47 = { class: "fv-help-block" }
const _hoisted_48 = { key: 1 }
const _hoisted_49 = { class: "col-lg-6 fv-row" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label required fw-bold fs-6" }, "Tempat Lahir", -1)
const _hoisted_51 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_52 = { class: "fv-help-block" }
const _hoisted_53 = { key: 1 }
const _hoisted_54 = { class: "row mb-6" }
const _hoisted_55 = { class: "col-lg-6 fv-row" }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label required fw-bold fs-6" }, "Provinsi", -1)
const _hoisted_57 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_58 = { class: "fv-help-block" }
const _hoisted_59 = { key: 1 }
const _hoisted_60 = {
  key: 0,
  class: "col-lg-6 fv-row"
}
const _hoisted_61 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label required fw-bold fs-6" }, "Kota/ Kabupaten", -1)
const _hoisted_62 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_63 = { class: "fv-help-block" }
const _hoisted_64 = { key: 1 }
const _hoisted_65 = {
  key: 1,
  class: "col-lg-6 fv-row"
}
const _hoisted_66 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label required fw-bold fs-6" }, "Kota/ Kabupaten", -1)
const _hoisted_67 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_68 = { class: "fv-help-block" }
const _hoisted_69 = { key: 1 }
const _hoisted_70 = { class: "row mb-6" }
const _hoisted_71 = {
  key: 0,
  class: "col-lg-6 fv-row"
}
const _hoisted_72 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label required fw-bold fs-6" }, "Kecamatan", -1)
const _hoisted_73 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_74 = { class: "fv-help-block" }
const _hoisted_75 = { key: 1 }
const _hoisted_76 = {
  key: 1,
  class: "col-lg-6 fv-row"
}
const _hoisted_77 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label required fw-bold fs-6" }, "Kecamatan", -1)
const _hoisted_78 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_79 = { class: "fv-help-block" }
const _hoisted_80 = { key: 1 }
const _hoisted_81 = { class: "col-lg-6 fv-row" }
const _hoisted_82 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label required fw-bold fs-6" }, "Alamat", -1)
const _hoisted_83 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_84 = { class: "fv-help-block" }
const _hoisted_85 = { key: 1 }
const _hoisted_86 = { class: "row mb-6" }
const _hoisted_87 = { class: "col-lg-6 fv-row" }
const _hoisted_88 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Tag", -1)
const _hoisted_89 = { class: "fv-plugins-message-container" }
const _hoisted_90 = { class: "fv-help-block" }
const _hoisted_91 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_92 = ["disabled"]
const _hoisted_93 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Simpan ", -1)
const _hoisted_94 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Silahkan Tunggu ... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_95 = [
  _hoisted_93,
  _hoisted_94
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_Field = _resolveComponent("Field")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_loading, {
        active: _ctx.isLoading,
        "is-full-page": _ctx.fullPage,
        color: _ctx.isColor,
        "background-color": _ctx.isBackgroundColor,
        opacity: _ctx.isOpacity
      }, null, 8, ["active", "is-full-page", "color", "background-color", "opacity"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Form, {
          id: "kt_account_profile_details_form",
          class: "form",
          novalidate: "novalidate",
          onSubmit: _cache[18] || (_cache[18] = ($event: any) => (_ctx.saveChanges1()))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _hoisted_8,
                  _createVNode(_component_Multiselect, {
                    name: "schoolId",
                    modelValue: _ctx.onlyId.schoolId,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.onlyId.schoolId) = $event)),
                    placeholder: "Pilih Sekolah",
                    mode: "single",
                    "create-option": false,
                    options: _ctx.items.listSekolah,
                    searchable: true,
                    label: "name",
                    "track-by": "name",
                    "value-prop": "_id",
                    onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.pilihSekolah($event)))
                  }, null, 8, ["modelValue", "options"]),
                  (_ctx.onlyId.schoolId == '')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.items.errorschoolId), 1)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_11))
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _hoisted_13,
                  _createVNode(_component_Field, {
                    type: "text",
                    name: "kelas",
                    class: "form-control form-control-lg",
                    placeholder: "Isi Kelas",
                    modelValue: _ctx.tambahSiswa.kelas,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.tambahSiswa.kelas) = $event))
                  }, null, 8, ["modelValue"]),
                  (_ctx.tambahSiswa.kelas == '')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                        _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.items.errorkelas), 1)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_16))
                ])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _hoisted_19,
                  _createVNode(_component_Field, {
                    type: "text",
                    name: "kelasDetail",
                    class: "form-control form-control-lg",
                    placeholder: "Isi Kelas Detail",
                    modelValue: _ctx.tambahSiswa.kelasDetail,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.tambahSiswa.kelasDetail) = $event))
                  }, null, 8, ["modelValue"]),
                  (_ctx.tambahSiswa.kelasDetail == '')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                        _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.items.errorkelasDetail), 1)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_22))
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _hoisted_24,
                  _createVNode(_component_Field, {
                    type: "number",
                    name: "identityNumber",
                    class: "form-control form-control-lg",
                    placeholder: "Isi Nomor Identitas",
                    modelValue: _ctx.tambahSiswa.identityNumber,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.tambahSiswa.identityNumber) = $event))
                  }, null, 8, ["modelValue"]),
                  (_ctx.tambahSiswa.identityNumber == '')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                        _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.items.erroridentityNumber), 1)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_27))
                ])
              ]),
              _hoisted_28,
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("div", _hoisted_30, [
                  _hoisted_31,
                  _createVNode(_component_Field, {
                    type: "text",
                    name: "name",
                    class: "form-control form-control-lg",
                    placeholder: "Isi Nama",
                    modelValue: _ctx.tambahSiswa.name,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.tambahSiswa.name) = $event))
                  }, null, 8, ["modelValue"]),
                  (_ctx.tambahSiswa.name == '')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                        _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.items.errorname), 1)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_34))
                ]),
                _createElementVNode("div", _hoisted_35, [
                  _hoisted_36,
                  _createVNode(_component_Field, {
                    as: "select",
                    class: "form-select form-select-lg fw-bold",
                    name: "gender",
                    placeholder: "Isi Jenis Kelamin",
                    autocomplete: "off",
                    modelValue: _ctx.tambahSiswa.gender,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.tambahSiswa.gender) = $event))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_37,
                      _hoisted_38,
                      _hoisted_39
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  (_ctx.tambahSiswa.gender == '')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                        _createElementVNode("div", _hoisted_41, _toDisplayString(_ctx.items.errorgender), 1)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_42))
                ])
              ]),
              _createElementVNode("div", _hoisted_43, [
                _createElementVNode("div", _hoisted_44, [
                  _hoisted_45,
                  _createVNode(_component_Field, {
                    type: "date",
                    name: "dateOfBirth",
                    class: "form-control form-control-lg",
                    placeholder: "Isi Tanggal Lahir",
                    modelValue: _ctx.tambahSiswa.dateOfBirth,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.tambahSiswa.dateOfBirth) = $event))
                  }, null, 8, ["modelValue"]),
                  (_ctx.tambahSiswa.dateOfBirth == '')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                        _createElementVNode("div", _hoisted_47, _toDisplayString(_ctx.items.errordateOfBirth), 1)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_48))
                ]),
                _createElementVNode("div", _hoisted_49, [
                  _hoisted_50,
                  _createVNode(_component_Field, {
                    type: "text",
                    name: "placeOfBirth",
                    class: "form-control form-control-lg",
                    placeholder: "Isi Tempat Lahir",
                    modelValue: _ctx.tambahSiswa.placeOfBirth,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.tambahSiswa.placeOfBirth) = $event))
                  }, null, 8, ["modelValue"]),
                  (_ctx.tambahSiswa.placeOfBirth == '')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                        _createElementVNode("div", _hoisted_52, _toDisplayString(_ctx.items.errorplaceOfBirth), 1)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_53))
                ])
              ]),
              _createElementVNode("div", _hoisted_54, [
                _createElementVNode("div", _hoisted_55, [
                  _hoisted_56,
                  _createVNode(_component_Multiselect, {
                    name: "province",
                    modelValue: _ctx.tambahSiswa.address.province,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.tambahSiswa.address.province) = $event)),
                    placeholder: "Pilih Provinsi",
                    mode: "single",
                    "create-option": false,
                    options: _ctx.items.provinsiOptions,
                    searchable: true,
                    label: "name",
                    "track-by": "name",
                    "value-prop": "name",
                    onChange: _cache[10] || (_cache[10] = ($event: any) => (_ctx.pilihProv($event)))
                  }, null, 8, ["modelValue", "options"]),
                  (_ctx.tambahSiswa.address.province == '')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                        _createElementVNode("div", _hoisted_58, _toDisplayString(_ctx.items.errorprovince), 1)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_59))
                ]),
                (_ctx.items.prov === '1')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                      _hoisted_61,
                      _createVNode(_component_Multiselect, {
                        name: "city",
                        modelValue: _ctx.city,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.city) = $event)),
                        placeholder: "Pilih Kota/Kabupaten",
                        mode: "single",
                        "create-option": false,
                        options: _ctx.items.kabupatenOptions,
                        searchable: true,
                        label: "name",
                        "track-by": "name",
                        "value-prop": "name",
                        onChange: _cache[12] || (_cache[12] = ($event: any) => (_ctx.pilihKab($event)))
                      }, null, 8, ["modelValue", "options"]),
                      (_ctx.tambahSiswa.address.city == '')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                            _createElementVNode("div", _hoisted_63, _toDisplayString(_ctx.items.errorcity), 1)
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_64))
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_65, [
                      _hoisted_66,
                      _createVNode(_component_Field, {
                        type: "text",
                        name: "detail",
                        class: "form-select form-select-lg fw-bold",
                        placeholder: "Pilih Kota/Kabupaten",
                        disabled: ""
                      }),
                      (_ctx.tambahSiswa.address.city == '')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                            _createElementVNode("div", _hoisted_68, _toDisplayString(_ctx.items.errorcity), 1)
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_69))
                    ]))
              ]),
              _createElementVNode("div", _hoisted_70, [
                (_ctx.items.kab === '1')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_71, [
                      _hoisted_72,
                      _createVNode(_component_Multiselect, {
                        name: "regency",
                        modelValue: _ctx.regency,
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.regency) = $event)),
                        placeholder: "Pilih Kecamatan",
                        mode: "single",
                        "create-option": false,
                        options: _ctx.items.kecamatanOptions,
                        searchable: true,
                        label: "name",
                        "track-by": "name",
                        "value-prop": "name",
                        onChange: _cache[14] || (_cache[14] = ($event: any) => (_ctx.pilihKec($event)))
                      }, null, 8, ["modelValue", "options"]),
                      (_ctx.tambahSiswa.address.regency == '')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_73, [
                            _createElementVNode("div", _hoisted_74, _toDisplayString(_ctx.items.errorregency), 1)
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_75))
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_76, [
                      _hoisted_77,
                      _createVNode(_component_Field, {
                        type: "text",
                        name: "detail",
                        class: "form-select form-select-lg fw-bold",
                        placeholder: "Pilih Kecamatan",
                        disabled: ""
                      }),
                      (_ctx.tambahSiswa.address.regency == '')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_78, [
                            _createElementVNode("div", _hoisted_79, _toDisplayString(_ctx.items.errorregency), 1)
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_80))
                    ])),
                _createElementVNode("div", _hoisted_81, [
                  _hoisted_82,
                  _createVNode(_component_Field, {
                    type: "text",
                    name: "detail",
                    class: "form-control form-control-lg",
                    placeholder: "Isi Alamat",
                    modelValue: _ctx.tambahSiswa.address.detail,
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.tambahSiswa.address.detail) = $event))
                  }, null, 8, ["modelValue"]),
                  (_ctx.tambahSiswa.address.detail == '')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_83, [
                        _createElementVNode("div", _hoisted_84, _toDisplayString(_ctx.items.errordetail), 1)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_85))
                ])
              ]),
              _createElementVNode("div", _hoisted_86, [
                _createElementVNode("div", _hoisted_87, [
                  _hoisted_88,
                  _createVNode(_component_el_form_item, { prop: "tags" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.tambahSiswa.tags,
                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.tambahSiswa.tags) = $event)),
                        class: "form-control",
                        multiple: "",
                        filterable: "",
                        "allow-create": "",
                        "default-first-option": "",
                        placeholder: "Isi Tags",
                        "allow-duplicates": "false"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_89, [
                    _createElementVNode("div", _hoisted_90, [
                      _createVNode(_component_ErrorMessage, { name: "tags" })
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_91, [
              _createElementVNode("button", {
                class: "btn btn-danger me-3",
                onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.$router.push('/superadmin/siswa')))
              }, " Batal "),
              _createElementVNode("button", {
                type: "submit",
                id: "kt_account_profile_details_submit",
                ref: "submitButton",
                class: "btn btn-primary",
                disabled: _ctx.items.disableButton
              }, _hoisted_95, 8, _hoisted_92)
            ])
          ]),
          _: 1
        })
      ])
    ])
  ], 64))
}